import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ShiftGroupService } from '../../../Model/ShiftGroup/shift-group.service';

@Component({
  selector: 'app-shift-groupform',
  standalone: true,
  imports: [FormsModule, CommonModule, NgSelectModule],
  templateUrl: './shift-groupform.component.html',
  styleUrl: './shift-groupform.component.scss'
})
export class ShiftGroupformComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() id!: number;

  filter = {
    SelectType: 'S',
    ESS_ShiftGroupMasterId: 0
  }

  Detail = {
    SelectType: 'Insert',
    ShiftGroupName: null,
    ESS_ShiftGroupMasterId: 0,
    UserId: null
  }
  constructor(
    private modalService: NgbModal,
    private toast: ToastService,
    private combo: ComboService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private shift: ShiftGroupService
  ) {
    this.common.getPageRights();
    this.Detail.ESS_ShiftGroupMasterId = this.id
    this.filter.ESS_ShiftGroupMasterId = this.id
  }

  ngOnInit(): void {
    if (this.id > 0) {
      this.GetData();
    }
  }

  GetData() {
    this.isDisabled = true;
    this.filter.ESS_ShiftGroupMasterId = this.id;
    this.shift.ESS_ShiftGroupMaster(this.filter).subscribe({
      next: (response) => {
        this.Detail.SelectType = 'Update';
        this.Detail.ShiftGroupName = response.Table[0].ShiftGroupName;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async Save() {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Do you want save?'
    modalRef.result.then((result: any) => {
     if ((this.id == 0 && this.common.PageRight.IsAdd) || (this.id > 0 && this.common.PageRight.IsEdit)) {
      if (result) {
        this.isDisabled = true;
        this.Detail.ESS_ShiftGroupMasterId = this.id
        this.shift.ESS_ShiftGroupMaster_Insert(this.Detail).subscribe({
          next: (response) => {
            if (response.Error_Code == '548' || response.Error_Code == '549') {
              this.activeModal.close(true);
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
            }
            else {
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {
      // Modal dismissed
    });
  }

  close() {
    this.activeModal.close();
  }
}
